export * from "./HighlightedText";
